export const serviceTableStyle = {
  div: { fontSize: "11px", lineHeight: 2, fontFamily: "Inter" },
  tableHead: {
    fontSize: "11px",

    "&.MuiTableCell-root.MuiTableCell-root": {
      paddingLeft: "3px",
      fontFamily: "Inter",
    },
  },
  serviceData: {
    border: "none",
    fontSize: "10px",
    "&.MuiTableCell-root.MuiTableCell-root": {
      paddingLeft: "3px",
      fontFamily: "Inter",
    },
  },
};
